import React from 'react';
import { GlobeIcon, LockIcon, UsersIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
const stack: {
  label: string;
  value: string;
}[] = [{
  label: '📘 Clinical Master System™ — 6 Premium Volumes',
  value: '$97 USD'
}, {
  label: '🧠 7-Step Clinical Diagnostic Framework',
  value: '$67 USD'
}, {
  label: '📋 Step-by-Step Clinical Protocols',
  value: '$47 USD'
}, {
  label: '🔎 Clinical Cases & Visual Resources',
  value: '$49 USD'
}, {
  label: '🎁 5 Exclusive Bonuses',
  value: '$154 USD'
}];
const SPOTS_TOTAL = 200;
const SPOTS_LEFT = 17;
export function Offer() {
  const filled = Math.round((SPOTS_TOTAL - SPOTS_LEFT) / SPOTS_TOTAL * 100);
  return <section id="offer" className="w-full bg-navy-950 px-4 py-14 text-white sm:px-6 sm:py-20" data-id="element-164" data-mp="3nvsh2ikwanen">
      <div className="mx-auto w-full max-w-2xl" data-id="element-165" data-mp="3swzpmjuv3qmd">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.22em] text-gold-400" data-id="element-166" data-mp="3su3rovj0l1xx">
          🏆 Special Launch Offer
        </p>
        <h2 className="mt-3 text-center font-display text-[27px] font-bold leading-[1.15] sm:text-4xl" data-id="element-167" data-mp="1kmjbepkeqayq">
          Here’s Everything You’ll Receive Today
        </h2>

        <ul className="mt-8 divide-y divide-white/10 rounded-3xl border border-white/10 bg-navy-900 px-5 py-2 sm:px-7" data-id="element-168" data-mp="1bks3rf6b3u28">
          {stack.map(row => <li key={row.label} className="flex items-start justify-between gap-4 py-3.5" data-id="element-169" data-mp="16n9xjwjobsxx">
              <span className="text-[14px] leading-snug text-white/80" data-id="element-170" data-mp="23aod7rhi7luw">{row.label}</span>
              <span className="shrink-0 text-[14px] font-bold text-white/50 line-through" data-id="element-171" data-mp="1zbfk8ouafs0e">
                {row.value}
              </span>
            </li>)}
          <li className="flex items-center justify-between gap-4 py-4" data-id="element-172" data-mp="1pkt50vqhh3i8">
            <span className="text-[12px] font-extrabold uppercase tracking-[0.14em] text-gold-400" data-id="element-173" data-mp="1piqjop09zyju">
              Total Value
            </span>
            <span className="font-display text-2xl font-bold text-white/60 line-through" data-id="element-174" data-mp="2i8yqjkpd2wj4">
              $414 USD
            </span>
          </li>
        </ul>

        <div className="mt-8 rounded-3xl border-2 border-gold-500 bg-navy-900 p-5 text-center sm:p-8" data-id="element-175" data-mp="317tmujz3xu7m">
          <p className="text-[14px] text-white/70" data-id="element-176" data-mp="2sd5h6spmeaia">
            But you don’t need to pay $414. Today, you can get the complete Clinical Master System™
            for:
          </p>
          <p className="mt-3 font-display text-6xl font-bold text-gold-400 sm:text-7xl" data-id="element-177" data-mp="2wco05ixvsbih">$27</p>
          <p className="mt-2 text-[12px] font-bold uppercase tracking-[0.14em] text-white/60" data-id="element-178" data-mp="2ih2f1murqbvc">
            One-Time Payment • Lifetime Access • Instant Download
          </p>
          <p className="mt-4 text-[13.5px] leading-relaxed text-white/60" data-id="element-179" data-mp="29fmdm4lxlk39">
            No monthly subscription. No recurring payments. No complicated enrollment. Just one
            payment and immediate access to the complete digital library.
          </p>

          <div className="mt-6" data-id="element-180" data-mp="bo9u5k5hcnnr">
            <CTAButton label="I want the Clinical Master System" data-id="element-181" data-mp="bn8gd7x2xn2c" />
          </div>

          <div className="mt-6" data-id="element-182" data-mp="1w5slmd0i104g">
            <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-white/55" data-id="element-183" data-mp="1w6u1qvwdgct1">
              ⏰ The offer ends in
            </p>
            <Countdown className="mt-3" data-id="element-184" data-mp="25w3v0f2yc1iq" />
          </div>

          <div className="mt-7 rounded-2xl border border-white/10 bg-navy-950/60 p-4 text-left" data-id="element-185" data-mp="25xopk4p9nkgl">
            <div className="flex items-center justify-between gap-3" data-id="element-186" data-mp="214cdsv5or859">
              <span className="flex items-center gap-2 text-[12px] font-bold uppercase tracking-wide text-white/70" data-id="element-187" data-mp="2ftibgeovkqb1">
                <UsersIcon className="h-4 w-4 text-gold-400" aria-hidden="true" data-id="element-188" data-mp="2auykfzvfcobt" />
                Spots at the launch price
              </span>
              <span className="text-[12px] font-extrabold text-gold-400" data-id="element-189" data-mp="2jwekpesiza2b">{SPOTS_LEFT} left</span>
            </div>
            <div className="mt-2.5 h-2.5 w-full overflow-hidden rounded-full bg-white/10" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={filled} aria-label="Spots already claimed at the launch price" data-id="element-190" data-mp="ugoy1baqt9nm">
              <div className="h-full rounded-full bg-gold-500" style={{
              width: `${filled}%`
            }} data-id="element-191" data-mp="vx2q23uyugrm" />
            </div>
            <p className="mt-2 text-[11.5px] text-white/50" data-id="element-192" data-mp="10y05i8olcwpf">
              {SPOTS_TOTAL - SPOTS_LEFT} of {SPOTS_TOTAL} spots already claimed. Once the last spots
              are taken, the promotional price is gone.
            </p>
          </div>

          <div className="mt-5 space-y-1.5" data-id="element-193" data-mp="d7mm16k2o66g">
            <p className="flex items-center justify-center gap-1.5 text-[12px] text-white/55" data-id="element-194" data-mp="d8fldmgpbtek">
              <GlobeIcon className="h-3.5 w-3.5 text-gold-400" aria-hidden="true" data-id="element-195" data-mp="i5ef43wgdyc8" />
              Currency conversion is handled automatically according to your country.
            </p>
            <p className="flex items-center justify-center gap-1.5 text-[12px] text-white/55" data-id="element-196" data-mp="3lmoaulnxg42i">
              <LockIcon className="h-3.5 w-3.5 text-gold-400" aria-hidden="true" data-id="element-197" data-mp="3qlr315it6ft2" />
              Secure payment • Instant access • 7-Day Guarantee
            </p>
          </div>
        </div>
      </div>
    </section>;
}